<template>
  <div id="playerKeyboard">
    <div id="playerKeyboardMain">
      <div id="modalPanel">
        <div id="closeAdminPinModal" @click="closePlayerKeyboard">
          <svg
            fill="white"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="357px"
            height="357px"
            viewBox="0 0 357 357"
            style="enable-background:new 0 0 357 357;"
            xml:space="preserve"
          >
            <g>
              <g id="close">
                <polygon
                  points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 
                              214.2,178.5 		"
                />
              </g>
            </g>
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
          </svg>
        </div>
      </div>
      <div id="playerKeyboardDisplayHolder">
        <div id="playerKeyboardStatus"></div>
        <div id="playerKeyboardDisplay">
          <div id="playerKeyboardCodes">
            <div v-for="(code, index) in codes" class="keyboard-codes" :key="index + 'i'">*</div>
          </div>
        </div>
      </div>
      <div id="playerKeyBoardBody">
        <div
          v-for="(number, index) in shuffledKeys"
          class="player-keyboard-button"
          :data-number="number"
          :key="index"
          @click="addCode(number)"
        >
          <p>{{ number }}</p>
        </div>
        <div class="player-keyboard-button-backspace" data-number="d" @click="removeCode()">
          <svg
            id="Capa_2"
            enable-background="new 0 0 64 64"
            height="512"
            viewBox="0 0 64 64"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m62.933 53.333h-44.8c-.315 0-.613-.139-.816-.38l-17.066-20.266c-.334-.397-.334-.977 0-1.374l17.067-20.267c.203-.241.501-.38.816-.38h44.8c.589 0 1.067.478 1.067 1.067v40.533c-.001.589-.479 1.067-1.068 1.067zm-44.304-2.133h43.237v-38.4h-43.237l-16.168 19.2z"
            />
            <path
              d="m46.933 41.6c-.273 0-.546-.105-.754-.313l-17.066-17.066c-.417-.417-.417-1.091 0-1.508.416-.417 1.092-.417 1.508 0l17.067 17.067c.417.417.417 1.091 0 1.508-.209.207-.482.312-.755.312z"
            />
            <path
              d="m29.867 41.6c-.273 0-.546-.105-.754-.313-.417-.417-.417-1.091 0-1.508l17.067-17.067c.416-.417 1.092-.417 1.508 0 .417.417.417 1.091 0 1.508l-17.067 17.067c-.208.208-.481.313-.754.313z"
            />
          </svg>
        </div>
        <div class="player-keyboard-button-enter" data-number="e" @click="confirmCodes">
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="484.5px"
            height="484.5px"
            viewBox="0 0 484.5 484.5"
            style="enable-background:new 0 0 484.5 484.5;"
            xml:space="preserve"
          >
            <g>
              <g id="player-keyboard-return">
                <polygon
                  points="433.5,114.75 433.5,216.75 96.9,216.75 188.7,124.95 153,89.25 0,242.25 153,395.25 188.7,359.55 96.9,267.75 
                                484.5,267.75 484.5,114.75 		"
                />
              </g>
            </g>
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['scannedString','keyboardType'],
  data() {
    return {
      keyboardNumbers: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      codes: [],
      shuffledKeys: [],
      codesLength:4
    }
  },
  methods: {
    addCode(code) {
      if (this.codes.length >= this.codesLength) {
        return;
      } else {
        this.codes.push(code);
      }
    },
    closePlayerKeyboard() {
      this.$emit('closePlayerKeyboard');
      this.shuffledKeys = this.shuffleKeys(this.keyboardNumbers);
    },
    removeCode() {
      if (this.codes.length > 0) {
        this.codes = this.codes.filter(loopCode => loopCode != this.codes.slice(-1)[0]);
      } 
    },
    confirmCodes() {
      this.$emit('confirmCodes', {
        type: this.keyboardType,
        codes: this.codes,
        scannedString: this.scannedString
      });
      this.codes = [];
    },
    shuffleKeys(a) {
      var j, x, i;
      for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
      }
      return a;
    },
  },
  mounted() {
    this.shuffledKeys = this.shuffleKeys(this.keyboardNumbers);
  }
};
</script>